import React, {useEffect, useState} from "react";
import * as API from "../../helpers/api";
import config from "../../config";
import Loading from "react-loader-spinner";
import {useLang} from "../../helpers/language";
import parse from "html-react-parser";

import NewsItem from "./NewsItem";
import useWindowSize from "../../assets/hooks/useWindowSize";
import {breakpoints} from "../../assets/js/helpers";
import "./news-slider.scss";
import {withLanguage, withDictionary} from "../../assets/js/contexts";
import {Swiper, SwiperSlide} from "swiper/react";
import SwiperCore, {Navigation, Pagination} from "swiper/core";

SwiperCore.use([Navigation]);
SwiperCore.use([Pagination]);

const NewsSlider = ({dictionary}) => { // const [news, setNews] = useState([]);
    const {width} = useWindowSize();
    const {lang} = useLang();
    const [isBusy, setBusy] = useState(true);
    const [blogPost, setBlogPost] = useState([]);
    const [blog, setBlog] = useState([]);

    useEffect(() => {
        (async () => {
            let rowBlogPost = await API.get(config.api.blogPost, {}, {}, true);
            setBlogPost(rowBlogPost);
            let rowBlog = await API.get(config.api.blog, {}, {}, true);
            setBlog(rowBlog[0]);
            setBusy(false);
        })();
    }, [isBusy]);

    if (isBusy) 
        return <Loading type="Oval" color="#FFBE03" className="loader"/>;
     else 
        return (
            <div>
                <div id="news-slider" className="container-fluid">
                    <div className="row no-gutters justify-content-center">
                        {
                        blog && (
                            <div className="col-8">
                                <h2>{
                                    blog?.title && blog.title[lang]
                                }</h2>
                                <div className="text-center">
                                    {
                                    parse(blog?.desc ? (blog.desc[lang] ? blog.desc[lang] : "") : "")
                                } </div>
                            </div>
                        )
                    }
                        <div className="col-12">
                            {
                            width > breakpoints.xs ? (
                                <div>
                                    <Swiper slidesPerView={1.5}
                                        spaceBetween={88}
                                        centeredSlides={true}
                                        pagination={
                                            {
                                                el: ".swiper-pagination",
                                                type: "bullets",
                                                clickable: true
                                            }
                                    }>
                                        {
                                        blogPost.map((post, index) => (
                                            <SwiperSlide key={index}>
                                                <NewsItem post={post}
                                                    lang={lang}
                                                    index={index}/>
                                            </SwiperSlide>
                                        ))
                                    }
                                        <div className="swiper-pagination"></div>
                                    </Swiper>
                                </div>
                            ) : (
                                <div className="row"
                                    style={
                                        {
                                            marginTop: 42,
                                            paddingLeft: 10,
                                            paddingRight: 10
                                        }
                                }>
                                    {
                                    blogPost.map((post, index) => (
                                        <div key={index}
                                            className="col-12 mb-4">
                                            <NewsItem post={post}
                                                lang={lang}
                                                baseUrl={undefined}/>
                                        </div>
                                    ))
                                } </div>
                            )
                        } </div>
                    </div>
                </div>
            </div>
        );
    
};

export default withLanguage(withDictionary(NewsSlider));
